import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiCallPost } from "../axios/axios";
import { setUserData } from "../redux/user";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logout = async () => {
    apiCallPost(
        "/api/v1/satyug/auth/logout",
      {},
      {},
      true,
      true
    )
      .then((data) => {
        if (data && !data.error) {
          localStorage.clear();
          dispatch(setUserData(""));
          navigate("/");
          
        }
      })
      .catch((error) => {});
  };
  return [logout];
};

export default useLogout;
